import React from 'react'

import Base from '../_Base'

const Switch = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M13,7.2 L7.7,7.2 L10.4,4.5 C10.8,4.1 10.8,3.5 10.4,3.1 C10,2.7 9.4,2.7 9,3.1 L4,8.1 L9,13 C9.2,13.2 9.4,13.3 9.7,13.3 C10,13.3 10.2,13.2 10.4,13 C10.8,12.6 10.8,12 10.4,11.6 L8,9.2 L13,9.2 C15.8,9.2 18,11.4 18,14.2 C18,17 15.8,19.2 13,19.2 L6.4,19.2 C5.8,19.2 5.4,19.6 5.4,20.2 C5.4,20.8 5.8,21.2 6.4,21.2 L13,21.2 C16.9,21.2 20,18.1 20,14.2 C20,10.3 16.9,7.2 13,7.2 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default Switch
